module.exports = __webpack_public_path__ + "static/media/badge.e28ce034.svg";